module.exports = __webpack_public_path__ + "static/media/cancelar.cfdbafe3.png";